import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
// import { all_routes } from "../../Router/all_routes";
import { useDispatch, useSelector } from "react-redux";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ChevronUp, RotateCcw } from "feather-icons-react/build/IconComponents";
import { setToogleHeader } from "../../core/redux/action";
import Select from 'react-select';
// import makeAnimated from 'react-select/animated';
import Axios from "axios";
import { API_BASE_URL, GET_STORE_SECURITY, GET_USER_PERMISSIONS, GET_USERS, UPDATE_STORE_SECURITY, UPDATE_USERMENU } from "../../Config";
import SecurityImg from './security.jpeg';
import { getUserPermissions } from "../../UserPermissions";


const UserRoles = () => {
  // const route = all_routes;
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);

  const [userDataSession, setUserDataSession] = useState([]);
  const [userPermissions, setUserPermissions] = useState([]);
  const [storeSecurity, setStoreSecurity] = useState([]);
  const [loading, setLoading] = useState(false);
  const [storeSecurityLoading, setStoreSecurityLoading] = useState(false);
  const [rolesDDL, setRolesDDL] = useState([]);
  const [usersDDL, setUsersDDL] = useState([]);
  const [moduleDDL, setModuleDDL] = useState([]);
  const [selectedModule, setSelectedModule] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [displayRoleSecurity, setDisplayRoleSecurity] = useState(true);
  const [displayStoreSecurity, setDisplayStoreSecurity] = useState(false);
  // const [isRead, setIsRead] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
      const userDataString = sessionStorage.getItem("userData");
      const rolesData = JSON.parse(sessionStorage.getItem('filteredDDLData_Roles'));
      if (userDataString) {
          const userData = JSON.parse(userDataString);
          setUserDataSession(userData);
          setRolesDDL(rolesData);
      } else {
        console.log("User data not found in sessionStorage");
        navigate('/');
      }
  }, []);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
        Axios.get(`${API_BASE_URL}${GET_USERS}?OrgId=${userDataSession.OrgId}`)
            .then(response => {
                if (response.data.Status) {
                    setUsersDDL(response.data.ResultData);
                } else {
                    console.error('Error fetching data:', response.data.ResultData);
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }
  }, [userDataSession]);

  const [permissions, setPermissions] = useState({
    isRead: 'd-none',
    // isWrite: 'd-none',
    // isDelete: 'd-none',
    // isExport: 'd-none'
  });

  useEffect(() => {
    const perms = getUserPermissions("User Roles");
    setPermissions(perms);
  }, []);
  
  const fetchUserPermissions = () => {
    setLoading(true);
    Axios.get(`${API_BASE_URL}${GET_USER_PERMISSIONS}?OrgId=${userDataSession.OrgId}&RoleId=${userDataSession.RoleId}&ModuleId=0`)
      .then((response) => {
        setUserPermissions(response.data.ResultData);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching user permissions:", error);
        setLoading(false);
      });

    Axios.get(`${API_BASE_URL}${GET_USER_PERMISSIONS}?OrgId=${userDataSession.OrgId}&RoleId=${userDataSession.RoleId}&ModuleId=1`)
      .then((response) => {
        setModuleDDL(response.data.ResultData);
      })
      .catch((error) => {
        console.error("Error fetching user permissions:", error);
      });
  };

  useEffect(() => {
    if (selectedRole) {
      const fetchUserPermissions = () => {
        setLoading(true);
        Axios.get(`${API_BASE_URL}${GET_USER_PERMISSIONS}?OrgId=${userDataSession.OrgId}&RoleId=${selectedRole.value}&ModuleId=0`)
          .then((response) => {
            setUserPermissions(response.data.ResultData);
            setLoading(false);
          })
          .catch((error) => {
            console.error("Error fetching user permissions:", error);
            setLoading(false);
          });
    
        Axios.get(`${API_BASE_URL}${GET_USER_PERMISSIONS}?OrgId=${userDataSession.OrgId}&RoleId=${selectedRole.value}&ModuleId=1`)
          .then((response) => {
            setModuleDDL(response.data.ResultData);
          })
          .catch((error) => {
            console.error("Error fetching user permissions:", error);
          });
      };
      fetchUserPermissions();
    }
  }, [userDataSession, selectedRole]);

  useEffect(() => {
    if (userDataSession && selectedModule) {
      const fetchUserPermissions = () => {
        setLoading(true);
        Axios.get(`${API_BASE_URL}${GET_USER_PERMISSIONS}?OrgId=${userDataSession.OrgId}&RoleId=${userDataSession.RoleId}&ModuleId=${selectedModule.value}`)
          .then((response) => {
            setUserPermissions(response.data.ResultData);
            // console.log(response.data.ResultData, 'permissons data')
            setLoading(false);
          })
          .catch((error) => {
            console.error("Error fetching user permissions:", error);
            setLoading(false);
          });
    
        Axios.get(`${API_BASE_URL}${GET_USER_PERMISSIONS}?OrgId=${userDataSession.OrgId}&RoleId=${userDataSession.RoleId}&ModuleId=1`)
          .then((response) => {
            setModuleDDL(response.data.ResultData);
          })
          .catch((error) => {
            console.error("Error fetching user permissions:", error);
          });
      };
      fetchUserPermissions();
    }
  }, [selectedModule, userDataSession]);

  const fetchUserStoreSecurity = () => {
    const api = `${API_BASE_URL}${GET_STORE_SECURITY}?OrgId=${userDataSession.OrgId}&UserId=${selectedEmployee.value}`;
    console.log(api);
    Axios.get(api)
      .then((response) => {
        setStoreSecurity(response.data.ResultData);
        setStoreSecurityLoading(false);
      })
      .catch((error) => {
        setStoreSecurityLoading(false);
        console.error("Error fetching user stores security:", error);
      });
  };

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId && selectedEmployee) {
      setStoreSecurityLoading(true);
      fetchUserStoreSecurity(); // Reuse fetch logic here
    }
  }, [userDataSession, selectedEmployee]);

  const moduleOptions = [
    { value: 0, label: 'All Modules' },
    ...(moduleDDL ? moduleDDL.map(mod => ({
      value: mod.AppMenuId,
      label: mod.MenuName
    })) : [])
  ];

  const handleRoleChange = (selectedOption) => {
    setSelectedRole(selectedOption);
  };

  const handleEmployeeChange = (selectedOption) => {
    setSelectedEmployee(selectedOption);
  };

  const handleModuleChange = (selectedOption) => {
    setSelectedModule(selectedOption);
  };

  const handleRoleClick = () => {
    setDisplayRoleSecurity(true);
    setDisplayStoreSecurity(false);
  };

  const handleStoreClick = () => {
    setDisplayRoleSecurity(false);
    setDisplayStoreSecurity(true);
  };

  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const handleCheckboxChange = (index, field) => {
    console.log(`Checkbox changed - Index: ${index}, Field: ${field}`);
    const updatedPermissions = [...userPermissions];
    
    // Toggle the value of the checkbox
    updatedPermissions[index][field] = !updatedPermissions[index][field];
    
    setUserPermissions(updatedPermissions);
  
    const updatedPermission = updatedPermissions[index];
    console.log(updatedPermission.Read ? 1 : 0, 'r')
    const requestData = {
      orgid: userDataSession.OrgId,
      RoleId: selectedRole ? selectedRole : userDataSession.RoleId,
      userid: userDataSession.UserId,
      MenuId: updatedPermission.AppMenuId,
      IsChecked: updatedPermission.Read ? 1 : 0,
      CanWrite: updatedPermission.Write ? 1 : 0,
      CanDelete: updatedPermission.Delete ? 1 : 0,
      CanExport: updatedPermission.Export ? 1 : 0,
      IsActive: updatedPermission.IsActive ? 1 : 0
    };
  
    console.log('Request data sending to API:', requestData);
  
    setLoading(true);
  
    Axios.post(`${API_BASE_URL}${UPDATE_USERMENU}`, requestData)
      .then(response => {
        console.log(response.data, 'final response');
        if (response.data[0].EffectCount === 1) {
          fetchUserPermissions(); 
        }
      })
      .catch(error => {
        console.error('Error updating permission:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // const handleStoreCheckboxChange = async (storeId, isActive) => {
  //   setStoreSecurityLoading(true);
  //   const data = {
  //     OrgId: userDataSession.OrgId,
  //     UserId: selectedEmployee?.value,
  //     StoreId: storeId,
  //     CreatedBy: userDataSession.UserId,
  //     IsActive: isActive ? 1 : 0,
  //   };

  //   console.log(data, 'data sending to api store security');
  //   try {
  //     const response = await fetch(`${API_BASE_URL}${UPDATE_STORE_SECURITY}`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify(data),
  //     });

  //     if (response.ok) {
  //       const result = await response.json();
  //       console.log('Update successfuls:', result);
  //       setStoreSecurityLoading(false);
  //     } else {
  //       console.error('Update failed:', response.statusText);
  //       setStoreSecurityLoading(false);
  //     }
  //   } catch (error) {
  //     console.error('Error updating store security:', error);
  //     setStoreSecurityLoading(false);
  //   }
  // };
  
  const handleStoreCheckboxChange = async (storeId, isActive) => {
    setStoreSecurityLoading(true);
    const data = {
      OrgId: userDataSession.OrgId,
      UserId: selectedEmployee?.value,
      StoreId: storeId,
      CreatedBy: userDataSession.UserId,
      IsActive: isActive ? 1 : 0,
    };
  
    console.log(data, 'data sending to api store security');
    try {
      const response = await fetch(`${API_BASE_URL}${UPDATE_STORE_SECURITY}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
  
      if (response.ok) {
        const result = await response.json();
        console.log('Update successful:', result);
        fetchUserStoreSecurity();
      } else {
        console.error('Update failed:', response.statusText);
        setStoreSecurityLoading(false);
      }
    } catch (error) {
      console.error('Error updating store security:', error);
      setStoreSecurityLoading(false);
    }
  };

  const styles = {
    loadingOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(255, 255, 255, 0.8)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000, // Ensure it covers other elements
    },
    
  };

  const [searchQuery, setSearchQuery] = useState("");
  const filteredPermissions = userPermissions?.filter(item =>
    item.MenuName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const [searchStoreQuery, setStoreSearchQuery] = useState("");
  const filteredStoreData = storeSecurity?.filter(item =>
    item.Name.toLowerCase().includes(searchStoreQuery.toLowerCase())
  );
  

  return (
    <div>
      <div className="page-wrapper">
        <div className="content settings-content">
          <div className="page-header settings-pg-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>User Roles</h4>
                <h6>Manage user roles on portal</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={() => {
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>
          <div className={`row`}>
            {loading && (
              <div style={styles.loadingOverlay}>
                <div className="loader"></div>
              </div>
            )}
            <div className={`col-xl-8  ${permissions.isRead}`}>
              <div className="settings-wrapper d-flex">
                <div className="settings-page-wrap">
                  <div className="setting-tile d-flex">
                    <h4 style={{ textDecoration: `${displayRoleSecurity ? 'underline' : ''}`, color: `${displayRoleSecurity ? 'blue' : '' }`, cursor: 'pointer' }} onClick={handleRoleClick}>Role Security</h4>
                    <h4 className="ms-3" style={{ textDecoration: `${displayStoreSecurity ? 'underline' : ''}`, cursor: 'pointer', color: `${displayStoreSecurity ? 'blue' : ''}` }} onClick={handleStoreClick}>Store Security</h4>
                    {displayRoleSecurity && 
                        <div className={`d-flex ms-auto me-5`}>
                            {/* <p className="ms-3 fw-bold" style={{ textDecoration: 'underline', cursor: 'pointer' }}>All</p>
                            <p className="ms-3" style={{ cursor: 'pointer' }}>Inventory</p>
                            <p className="ms-3" style={{ cursor: 'pointer' }}>Products</p>
                            <p className="ms-3" style={{ cursor: 'pointer' }}>Sales</p> */}
                        </div>
                    }
                  </div>
                  <div className="security-settings">
                    {/* Role security */}
                    {displayRoleSecurity && 
                        <>
                            <div className={`d-flex mt-3`}>
                                <div className="col-4">
                                    <label>Select Role</label>
                                    <Select
                                        className="select"
                                        options={rolesDDL?.map(role => ({
                                          value: role.ItemId,
                                          label: role.ItemValue
                                      }))}
                                      value={selectedRole || null}
                                      onChange={handleRoleChange}
                                    />
                                </div>
                                <div className="col-4 ms-3">
                                    <label>Select Module</label>
                                    <Select
                                        className="select"
                                        options={moduleOptions}
                                        value={selectedModule || null}
                                        onChange={handleModuleChange}
                                    />
                                </div>
                            </div>
                            <div className={`table-responsive no-pagination`}  style={{ maxHeight: '30rem', overflowY: 'auto' }}>
                                <table className="table datanew">
                                  <thead className="">
                                    <tr>
                                      <th>Menu</th>
                                      <th>Read</th>
                                      <th>Write</th>
                                      <th>Delete</th>
                                      <th>Export</th>
                                      <th>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {filteredPermissions && filteredPermissions?.map((item, index) => (
                                      <tr key={index}>
                                        <td>{item.MenuName}</td>
                                        <td>
                                          <div className="status-toggle modal-status">
                                            <input
                                              type="checkbox"
                                              id={`read-${index}`}
                                              className="check"
                                              checked={item.Read === true}
                                              onChange={() => handleCheckboxChange(index, 'Read')}
                                              disabled={loading}
                                            />
                                            <label htmlFor={`read-${index}`} className="checktoggle"></label>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="status-toggle modal-status">
                                            <input
                                              type="checkbox"
                                              id={`write-${index}`}
                                              className="check"
                                              checked={item.Write === true}
                                              onChange={() => handleCheckboxChange(index, 'Write')}
                                              disabled={loading}
                                            />
                                            <label htmlFor={`write-${index}`} className="checktoggle"></label>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="status-toggle modal-status">
                                            <input
                                              type="checkbox"
                                              id={`delete-${index}`}
                                              className="check"
                                              checked={item.Delete === true}
                                              onChange={() => handleCheckboxChange(index, 'Delete')}
                                              disabled={loading}
                                            />
                                            <label htmlFor={`delete-${index}`} className="checktoggle"></label>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="status-toggle modal-status">
                                            <input
                                              type="checkbox"
                                              id={`export-${index}`}
                                              className="check"
                                              checked={item.Export === true}
                                              onChange={() => handleCheckboxChange(index, 'Export')}
                                              disabled={loading}
                                            />
                                            <label htmlFor={`export-${index}`} className="checktoggle"></label>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="status-toggle modal-status">
                                            <input
                                              type="checkbox"
                                              id={`isactive-${index}`}
                                              className="check"
                                              checked={item.IsActive === true}
                                              onChange={() => handleCheckboxChange(index, 'IsActive')}
                                              disabled={loading}
                                            />
                                            <label htmlFor={`isactive-${index}`} className="checktoggle"></label>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                                {/* <div className="text-end settings-bottom-btn">
                                    <Link to="#" className="btn btn-cancel me-2">
                                      Reset
                                    </Link>
                                    <Link
                                      to={route.generalsettings}
                                      className="btn btn-submit"
                                    >
                                      Save Changes
                                    </Link>
                                </div> */}
                            </div>
                        </>
                    }
                    {/* Store security */}
                    { storeSecurityLoading ? <div className="loader d-flex m-auto mt-5"></div> : displayStoreSecurity && 
                        <div className={`col-xl-12`} style= {{ display: displayStoreSecurity, }}>
                            <div className="settings-wrapper d-flex">
                                <div className="settings-page-wrap">
                                    <div className="security-settings mt-4">
                                        <label className="form-label">Select Employee</label>
                                        <Select
                                            className="select staff"
                                            options={usersDDL?.map(user => ({
                                              value: user.Id,
                                              label: user.Name
                                            }))}
                                            value={selectedEmployee || null}
                                            onChange={handleEmployeeChange}
                                          />
                                        <div className="table-responsive no-pagination" style={{ maxHeight: '30rem', overflowY: 'auto' }} >
                                            <table className="table  datanew">
                                                <thead>
                                                    <tr>
                                                        <th>Store </th>
                                                        <th>Location </th>
                                                        <th>Accessed</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="custom-table-data">
                                                  {filteredStoreData && filteredStoreData?.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.Name}</td>
                                                        <td>{item.City}</td>
                                                        <td>
                                                            <div className="status-toggle modal-status">
                                                              <input
                                                                type="checkbox"
                                                                id={`store-${item.Id}`}
                                                                className="check"
                                                                checked={item.ExistOrNot === 1}
                                                                onChange={(e) => handleStoreCheckboxChange(item.Id, e.target.checked)}
                                                              />
                                                              <label htmlFor={`store-${item.Id}`} className="checktoggle"></label>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                  ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                  </div>
                </div>
              </div>
            </div>

            <div className={`col-xl-4  ${permissions.isRead}`} style={{ display: displayRoleSecurity ? 'block' : 'none' }}>
              <input 
                type="text"
                className="form-control"
                placeholder="Search menu item..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{ display: displayRoleSecurity ? 'block' : 'none' }}              
              />
              <input 
                type="text"
                className="form-control"
                placeholder="Search store..."
                value={searchStoreQuery}
                onChange={(e) => setStoreSearchQuery(e.target.value)}
                style={{ display: displayStoreSecurity ? 'block' : 'none' }}              
              />
              <img src={SecurityImg} alt="securityimg"  style={{ marginTop: '2rem' }}/>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserRoles;
